var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79,104c0,8.28 -6.72,15 -15,15c-8.28,0 -15,-6.72 -15,-15",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.54,46.4c-0.24,0 -0.49,-0.03 -0.73,-0.09c-1.61,-0.4 -2.58,-2.03 -2.18,-3.64c3.12,-12.48 10.55,-23.53 20.91,-31.1c1.34,-0.98 3.21,-0.69 4.19,0.65c0.98,1.34 0.69,3.21 -0.65,4.19c-9.23,6.74 -15.84,16.58 -18.63,27.71c-0.35,1.37 -1.57,2.28 -2.91,2.28z",
    fill: "#ff2847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46,46.4c-1.34,0 -2.57,-0.91 -2.91,-2.27c-2.78,-11.12 -9.4,-20.97 -18.63,-27.71c-1.34,-0.98 -1.63,-2.85 -0.65,-4.19c0.98,-1.34 2.86,-1.63 4.19,-0.65c10.36,7.57 17.79,18.61 20.91,31.1c0.4,1.61 -0.58,3.24 -2.18,3.64c-0.24,0.05 -0.48,0.08 -0.73,0.08z",
    fill: "#ff2847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,104h-64.38c-6.51,0 -11.28,-6.11 -9.7,-12.43l10.83,-43.32c3.56,-14.25 16.37,-24.25 31.06,-24.25v0c14.69,0 27.5,10 31.06,24.25l10.83,43.32c1.58,6.32 -3.19,12.43 -9.7,12.43z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,107h-64.38c-4.03,0 -7.77,-1.82 -10.25,-5c-2.48,-3.18 -3.34,-7.24 -2.37,-11.15l10.83,-43.32c3.91,-15.62 17.88,-26.53 33.98,-26.53c16.1,0 30.07,10.91 33.97,26.53l10.83,43.32c0.98,3.91 0.12,7.98 -2.37,11.15c-2.47,3.18 -6.21,5 -10.24,5zM64,27c-13.34,0 -24.92,9.04 -28.15,21.98l-10.83,43.32c-0.53,2.11 -0.06,4.29 1.27,6.01c1.34,1.71 3.35,2.69 5.52,2.69h64.38c2.17,0 4.18,-0.98 5.52,-2.69c1.34,-1.71 1.8,-3.9 1.27,-6.01l-10.83,-43.32c-3.23,-12.94 -14.81,-21.98 -28.15,-21.98z",
    fill: "#2d3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.97,113c-0.62,0 -1.24,0.18 -1.74,0.56c-2.01,1.53 -4.51,2.44 -7.23,2.44c-2.72,0 -5.22,-0.91 -7.23,-2.44c-0.5,-0.38 -1.11,-0.56 -1.74,-0.56v0c-2.83,0 -4.13,3.63 -1.88,5.34c3.02,2.3 6.78,3.66 10.85,3.66c4.07,0 7.83,-1.36 10.85,-3.66c2.25,-1.71 0.95,-5.34 -1.88,-5.34z",
    fill: "#2d3748"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultNotificationIcon);
export default __webpack_public_path__ + "static/media/default-notification-icon.5efc8f6259af1f7fbbf0c5d9aac9478d.svg";
export { ForwardRef as ReactComponent };